export default "__VITE_ASSET__BqnF8z2M__"